import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/public.css'
import store from './store'
import BaiduMap from 'vue-baidu-map'
import './less/toast.css';
import Toast from 'vue2-toast';

Vue.use(Toast);
Vue.config.productionTip = false
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'abM7s3dv0svDwjg43eg21iG2'
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
